//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class V1DealersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    //custom code to format date without localization
    formatDateToLocalISO(date: Date): string {
        const pad = (num: number) => num.toString().padStart(2, '0');
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getAllDealers(deletedState: DeletedStateEnum, search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<DealerDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/dealers/list?";

                            if (deletedState === undefined || deletedState === null)
                throw new Error("The parameter 'deletedState' must be defined and cannot be null.");
            else
                            url_ += "deletedState=" + encodeURIComponent("" + deletedState) + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDealers(_response);
        });
    }

    protected processGetAllDealers(response: AxiosResponse): Promise<DealerDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = DealerDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<DealerDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    getDealer(dealerId: number, cancelToken?: CancelToken): Promise<DealerDto> {
        let url_ = this.baseUrl + "/api/v1/dealers/{dealerId}";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDealer(_response);
        });
    }

    protected processGetDealer(response: AxiosResponse): Promise<DealerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = DealerDto.fromJS(resultData200);
            return Promise.resolve<DealerDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerDto>(null as any);
    }

    /**
     * @return OK
     */
    getDealerOwner(dealerId: number, cancelToken?: CancelToken): Promise<DealerOwnerDto> {
        let url_ = this.baseUrl + "/api/v1/dealers/{dealerId}/owner";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDealerOwner(_response);
        });
    }

    protected processGetDealerOwner(response: AxiosResponse): Promise<DealerOwnerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = DealerOwnerDto.fromJS(resultData200);
            return Promise.resolve<DealerOwnerDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerOwnerDto>(null as any);
    }

    /**
     * @return OK
     */
    getDealerStatus(dealerId: number, cancelToken?: CancelToken): Promise<DealerStatusDto> {
        let url_ = this.baseUrl + "/api/v1/dealers/{dealerId}/status";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDealerStatus(_response);
        });
    }

    protected processGetDealerStatus(response: AxiosResponse): Promise<DealerStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = DealerStatusDto.fromJS(resultData200);
            return Promise.resolve<DealerStatusDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerStatusDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @return OK
     */
    getDealerIdsAndNames(deletedState: DeletedStateEnum, search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, cancelToken?: CancelToken): Promise<DealerIdsNamesDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/dealers/ids-names?";

                            if (deletedState === undefined || deletedState === null)
                throw new Error("The parameter 'deletedState' must be defined and cannot be null.");
            else
                            url_ += "deletedState=" + encodeURIComponent("" + deletedState) + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDealerIdsAndNames(_response);
        });
    }

    protected processGetDealerIdsAndNames(response: AxiosResponse): Promise<DealerIdsNamesDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = DealerIdsNamesDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<DealerIdsNamesDtoPagedDataResponseDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerIdsNamesDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param includeDealerIdZero (optional) 
     * @return OK
     */
    getDealerIdsAndNamesWithPossibleZero(deletedState: DeletedStateEnum, search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, includeDealerIdZero?: boolean | undefined, cancelToken?: CancelToken): Promise<DealerIdsNamesDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/dealers/ids-names-with-possible-zero?";

                            if (deletedState === undefined || deletedState === null)
                throw new Error("The parameter 'deletedState' must be defined and cannot be null.");
            else
                            url_ += "deletedState=" + encodeURIComponent("" + deletedState) + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (includeDealerIdZero === null)
                throw new Error("The parameter 'includeDealerIdZero' cannot be null.");
            else if (includeDealerIdZero !== undefined)
                            url_ += "includeDealerIdZero=" + encodeURIComponent("" + includeDealerIdZero) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDealerIdsAndNamesWithPossibleZero(_response);
        });
    }

    protected processGetDealerIdsAndNamesWithPossibleZero(response: AxiosResponse): Promise<DealerIdsNamesDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = DealerIdsNamesDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<DealerIdsNamesDtoPagedDataResponseDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerIdsNamesDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @return OK
     */
    getDealerIdsNamesAndTimesZones(deletedState: DeletedStateEnum, search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, cancelToken?: CancelToken): Promise<DealerIdsNamesTimeZonesDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/dealers/ids-names-timezones?";

                            if (deletedState === undefined || deletedState === null)
                throw new Error("The parameter 'deletedState' must be defined and cannot be null.");
            else
                            url_ += "deletedState=" + encodeURIComponent("" + deletedState) + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDealerIdsNamesAndTimesZones(_response);
        });
    }

    protected processGetDealerIdsNamesAndTimesZones(response: AxiosResponse): Promise<DealerIdsNamesTimeZonesDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = DealerIdsNamesTimeZonesDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<DealerIdsNamesTimeZonesDtoPagedDataResponseDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerIdsNamesTimeZonesDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    getDealerIdAndName(dealerId: number, deletedState: DeletedStateEnum, cancelToken?: CancelToken): Promise<DealerIdsNamesDto> {
        let url_ = this.baseUrl + "/api/v1/dealers/{dealerId}/ids-names?";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                                    if (deletedState === undefined || deletedState === null)
                throw new Error("The parameter 'deletedState' must be defined and cannot be null.");
            else
                            url_ += "deletedState=" + encodeURIComponent("" + deletedState) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDealerIdAndName(_response);
        });
    }

    protected processGetDealerIdAndName(response: AxiosResponse): Promise<DealerIdsNamesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = DealerIdsNamesDto.fromJS(resultData200);
            return Promise.resolve<DealerIdsNamesDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerIdsNamesDto>(null as any);
    }

    /**
     * @return OK
     */
    getDealerIdNameAndTimeZone(dealerId: number, deletedState: DeletedStateEnum, cancelToken?: CancelToken): Promise<DealerIdsNamesTimeZonesDto> {
        let url_ = this.baseUrl + "/api/v1/dealers/{dealerId}/ids-names-timezone?";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                                    if (deletedState === undefined || deletedState === null)
                throw new Error("The parameter 'deletedState' must be defined and cannot be null.");
            else
                            url_ += "deletedState=" + encodeURIComponent("" + deletedState) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDealerIdNameAndTimeZone(_response);
        });
    }

    protected processGetDealerIdNameAndTimeZone(response: AxiosResponse): Promise<DealerIdsNamesTimeZonesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = DealerIdsNamesTimeZonesDto.fromJS(resultData200);
            return Promise.resolve<DealerIdsNamesTimeZonesDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerIdsNamesTimeZonesDto>(null as any);
    }

    /**
     * @return OK
     */
    getTimeZones( cancelToken?: CancelToken): Promise<TimeZoneDtoNotPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/dealers/time-zones";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeZones(_response);
        });
    }

    protected processGetTimeZones(response: AxiosResponse): Promise<TimeZoneDtoNotPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = TimeZoneDtoNotPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<TimeZoneDtoNotPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeZoneDtoNotPagedDataResponseDto>(null as any);
    }

    /**
     * @param dealerId (optional) 
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getContacts(dealerId?: number | undefined, search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<DealerContactDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/dealers/contacts?";

                            if (dealerId === null)
                throw new Error("The parameter 'dealerId' cannot be null.");
            else if (dealerId !== undefined)
                            url_ += "dealerId=" + encodeURIComponent("" + dealerId) + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContacts(_response);
        });
    }

    protected processGetContacts(response: AxiosResponse): Promise<DealerContactDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = DealerContactDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<DealerContactDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerContactDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createContact(body?: CreateDealerContactDto | undefined, cancelToken?: CancelToken): Promise<DealerContactDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/dealers/contacts";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateContact(_response);
        });
    }

    protected processCreateContact(response: AxiosResponse): Promise<DealerContactDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data as string;
            let result201: any = null;
            let resultData201  = JSON.parse(_responseText);
            result201 = DealerContactDtoApiResponseDto.fromJS(resultData201);
            return Promise.resolve<DealerContactDtoApiResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerContactDtoApiResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    getOpenInvoiceTotals(dealerId: number, cancelToken?: CancelToken): Promise<DealerInvoiceTotalsDto> {
        let url_ = this.baseUrl + "/api/v1/dealers/{dealerId}/invoices/open-totals";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOpenInvoiceTotals(_response);
        });
    }

    protected processGetOpenInvoiceTotals(response: AxiosResponse): Promise<DealerInvoiceTotalsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = DealerInvoiceTotalsDto.fromJS(resultData200);
            return Promise.resolve<DealerInvoiceTotalsDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerInvoiceTotalsDto>(null as any);
    }

    /**
     * @param productType (optional) 
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @param ignoreExpiringDiscounts (optional) 
     * @return OK
     */
    getProducts(dealerId: number, productType?: ProductTypeEnum | undefined, search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, ignoreExpiringDiscounts?: boolean | undefined, cancelToken?: CancelToken): Promise<ProductDealerWithTotalsDto> {
        let url_ = this.baseUrl + "/api/v1/dealers/{dealerId}/products?";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                                    if (productType === null)
                throw new Error("The parameter 'productType' cannot be null.");
            else if (productType !== undefined)
                            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                            if (ignoreExpiringDiscounts === null)
                throw new Error("The parameter 'ignoreExpiringDiscounts' cannot be null.");
            else if (ignoreExpiringDiscounts !== undefined)
                            url_ += "ignoreExpiringDiscounts=" + encodeURIComponent("" + ignoreExpiringDiscounts) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProducts(_response);
        });
    }

    protected processGetProducts(response: AxiosResponse): Promise<ProductDealerWithTotalsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ProductDealerWithTotalsDto.fromJS(resultData200);
            return Promise.resolve<ProductDealerWithTotalsDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDealerWithTotalsDto>(null as any);
    }

    /**
     * @return OK
     */
    getBillingInformation(dealerId: number, cancelToken?: CancelToken): Promise<DealerBillingInformationDto> {
        let url_ = this.baseUrl + "/api/v1/dealers/{dealerId}/billing-information";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBillingInformation(_response);
        });
    }

    protected processGetBillingInformation(response: AxiosResponse): Promise<DealerBillingInformationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = DealerBillingInformationDto.fromJS(resultData200);
            return Promise.resolve<DealerBillingInformationDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerBillingInformationDto>(null as any);
    }

    /**
     * @return OK
     */
    apiTest( cancelToken?: CancelToken): Promise<TestDto> {
        let url_ = this.baseUrl + "/api/v1/dealers/tests";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiTest(_response);
        });
    }

    protected processApiTest(response: AxiosResponse): Promise<TestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = TestDto.fromJS(resultData200);
            return Promise.resolve<TestDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestDto>(null as any);
    }

    /**
     * @return OK
     */
    apiTestUnhandledException( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/dealers/tests/exception";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiTestUnhandledException(_response);
        });
    }

    protected processApiTestUnhandledException(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postApiTestUnhandledException(body?: any | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/dealers/tests/exception";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostApiTestUnhandledException(_response);
        });
    }

    protected processPostApiTestUnhandledException(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    apiTestHandledServiceException( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/dealers/tests/exception/service";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiTestHandledServiceException(_response);
        });
    }

    protected processApiTestHandledServiceException(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ApiResponseDto implements IApiResponseDto {
    id!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): ApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): ApiResponseDto {
        const json = this.toJSON();
        let result = new ApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IApiResponseDto {
    id: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CreateDealerContactDto implements ICreateDealerContactDto {
    dealerContactId!: number;
    dealerId!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    createdById!: number;
    createdDate!: Date;
    lastModifiedById!: number;
    lastModifiedDate!: Date;
    deleted!: boolean;
    oldsalesforceid?: string | undefined;
    secondaryPhone?: string | undefined;
    tertiaryPhone?: string | undefined;

    constructor(data?: ICreateDealerContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerContactId = _data["dealerContactId"];
            this.dealerId = _data["dealerId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedById = _data["lastModifiedById"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.oldsalesforceid = _data["oldsalesforceid"];
            this.secondaryPhone = _data["secondaryPhone"];
            this.tertiaryPhone = _data["tertiaryPhone"];
        }
    }

    static fromJS(data: any): CreateDealerContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDealerContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerContactId"] = this.dealerContactId;
        data["dealerId"] = this.dealerId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedById"] = this.lastModifiedById;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["oldsalesforceid"] = this.oldsalesforceid;
        data["secondaryPhone"] = this.secondaryPhone;
        data["tertiaryPhone"] = this.tertiaryPhone;
        return data;
    }

    clone(): CreateDealerContactDto {
        const json = this.toJSON();
        let result = new CreateDealerContactDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDealerContactDto {
    dealerContactId: number;
    dealerId: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    createdById: number;
    createdDate: Date;
    lastModifiedById: number;
    lastModifiedDate: Date;
    deleted: boolean;
    oldsalesforceid?: string | undefined;
    secondaryPhone?: string | undefined;
    tertiaryPhone?: string | undefined;
}

export class DealerBillingInformationDto implements IDealerBillingInformationDto {
    dealerBillingInformationId!: number;
    dealerGroupId?: number | undefined;
    dealerId?: number | undefined;
    invoiceTypeId?: number | undefined;
    billingAddress1?: string | undefined;
    billingAddress2?: string | undefined;
    billingCity?: string | undefined;
    billingState?: string | undefined;
    billingPostalZip?: string | undefined;
    creditCardTypeId?: number | undefined;
    encryptedCcnumber?: string | undefined;
    encryptedCcsecurityCode?: string | undefined;
    cclast4?: string | undefined;
    ccexpirationDate?: string | undefined;
    bankName?: string | undefined;
    encryptedRoutingNumber?: string | undefined;
    encryptedAccountNumber?: string | undefined;
    firstInvoiceDate?: Date | undefined;
    billMonth?: number | undefined;
    billDay?: number | undefined;
    billYear?: number | undefined;
    gracePeriodDays?: number | undefined;
    createdDate?: Date | undefined;
    lastModifiedDate?: Date | undefined;
    createdById?: number | undefined;
    lastModifiedById?: number | undefined;
    allowedCars?: number | undefined;
    allowedPhotos?: number | undefined;
    recurringToken?: string | undefined;
    annually!: boolean;
    quarterly!: boolean;
    emailInvoice!: boolean;
    printInvoice!: boolean;
    billTo?: string | undefined;
    detailedBilling?: boolean | undefined;
    allowedSoldPhotos?: number | undefined;

    constructor(data?: IDealerBillingInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerBillingInformationId = _data["dealerBillingInformationId"];
            this.dealerGroupId = _data["dealerGroupId"];
            this.dealerId = _data["dealerId"];
            this.invoiceTypeId = _data["invoiceTypeId"];
            this.billingAddress1 = _data["billingAddress1"];
            this.billingAddress2 = _data["billingAddress2"];
            this.billingCity = _data["billingCity"];
            this.billingState = _data["billingState"];
            this.billingPostalZip = _data["billingPostalZip"];
            this.creditCardTypeId = _data["creditCardTypeId"];
            this.encryptedCcnumber = _data["encryptedCcnumber"];
            this.encryptedCcsecurityCode = _data["encryptedCcsecurityCode"];
            this.cclast4 = _data["cclast4"];
            this.ccexpirationDate = _data["ccexpirationDate"];
            this.bankName = _data["bankName"];
            this.encryptedRoutingNumber = _data["encryptedRoutingNumber"];
            this.encryptedAccountNumber = _data["encryptedAccountNumber"];
            this.firstInvoiceDate = _data["firstInvoiceDate"] ? new Date(_data["firstInvoiceDate"].toString()) : <any>undefined;
            this.billMonth = _data["billMonth"];
            this.billDay = _data["billDay"];
            this.billYear = _data["billYear"];
            this.gracePeriodDays = _data["gracePeriodDays"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastModifiedById = _data["lastModifiedById"];
            this.allowedCars = _data["allowedCars"];
            this.allowedPhotos = _data["allowedPhotos"];
            this.recurringToken = _data["recurringToken"];
            this.annually = _data["annually"];
            this.quarterly = _data["quarterly"];
            this.emailInvoice = _data["emailInvoice"];
            this.printInvoice = _data["printInvoice"];
            this.billTo = _data["billTo"];
            this.detailedBilling = _data["detailedBilling"];
            this.allowedSoldPhotos = _data["allowedSoldPhotos"];
        }
    }

    static fromJS(data: any): DealerBillingInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerBillingInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerBillingInformationId"] = this.dealerBillingInformationId;
        data["dealerGroupId"] = this.dealerGroupId;
        data["dealerId"] = this.dealerId;
        data["invoiceTypeId"] = this.invoiceTypeId;
        data["billingAddress1"] = this.billingAddress1;
        data["billingAddress2"] = this.billingAddress2;
        data["billingCity"] = this.billingCity;
        data["billingState"] = this.billingState;
        data["billingPostalZip"] = this.billingPostalZip;
        data["creditCardTypeId"] = this.creditCardTypeId;
        data["encryptedCcnumber"] = this.encryptedCcnumber;
        data["encryptedCcsecurityCode"] = this.encryptedCcsecurityCode;
        data["cclast4"] = this.cclast4;
        data["ccexpirationDate"] = this.ccexpirationDate;
        data["bankName"] = this.bankName;
        data["encryptedRoutingNumber"] = this.encryptedRoutingNumber;
        data["encryptedAccountNumber"] = this.encryptedAccountNumber;
        data["firstInvoiceDate"] = this.firstInvoiceDate ? this.firstInvoiceDate.toISOString() : <any>undefined;
        data["billMonth"] = this.billMonth;
        data["billDay"] = this.billDay;
        data["billYear"] = this.billYear;
        data["gracePeriodDays"] = this.gracePeriodDays;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastModifiedById"] = this.lastModifiedById;
        data["allowedCars"] = this.allowedCars;
        data["allowedPhotos"] = this.allowedPhotos;
        data["recurringToken"] = this.recurringToken;
        data["annually"] = this.annually;
        data["quarterly"] = this.quarterly;
        data["emailInvoice"] = this.emailInvoice;
        data["printInvoice"] = this.printInvoice;
        data["billTo"] = this.billTo;
        data["detailedBilling"] = this.detailedBilling;
        data["allowedSoldPhotos"] = this.allowedSoldPhotos;
        return data;
    }

    clone(): DealerBillingInformationDto {
        const json = this.toJSON();
        let result = new DealerBillingInformationDto();
        result.init(json);
        return result;
    }
}

export interface IDealerBillingInformationDto {
    dealerBillingInformationId: number;
    dealerGroupId?: number | undefined;
    dealerId?: number | undefined;
    invoiceTypeId?: number | undefined;
    billingAddress1?: string | undefined;
    billingAddress2?: string | undefined;
    billingCity?: string | undefined;
    billingState?: string | undefined;
    billingPostalZip?: string | undefined;
    creditCardTypeId?: number | undefined;
    encryptedCcnumber?: string | undefined;
    encryptedCcsecurityCode?: string | undefined;
    cclast4?: string | undefined;
    ccexpirationDate?: string | undefined;
    bankName?: string | undefined;
    encryptedRoutingNumber?: string | undefined;
    encryptedAccountNumber?: string | undefined;
    firstInvoiceDate?: Date | undefined;
    billMonth?: number | undefined;
    billDay?: number | undefined;
    billYear?: number | undefined;
    gracePeriodDays?: number | undefined;
    createdDate?: Date | undefined;
    lastModifiedDate?: Date | undefined;
    createdById?: number | undefined;
    lastModifiedById?: number | undefined;
    allowedCars?: number | undefined;
    allowedPhotos?: number | undefined;
    recurringToken?: string | undefined;
    annually: boolean;
    quarterly: boolean;
    emailInvoice: boolean;
    printInvoice: boolean;
    billTo?: string | undefined;
    detailedBilling?: boolean | undefined;
    allowedSoldPhotos?: number | undefined;
}

export class DealerContactDto implements IDealerContactDto {
    dealerContactId!: number;
    dealerId!: number;
    firstName!: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    createdById!: number;
    createdDate!: Date;
    lastModifiedById!: number;
    lastModifiedDate!: Date;
    deleted!: boolean;
    oldsalesforceid?: string | undefined;
    secondaryPhone?: string | undefined;
    tertiaryPhone?: string | undefined;

    constructor(data?: IDealerContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerContactId = _data["dealerContactId"];
            this.dealerId = _data["dealerId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedById = _data["lastModifiedById"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.oldsalesforceid = _data["oldsalesforceid"];
            this.secondaryPhone = _data["secondaryPhone"];
            this.tertiaryPhone = _data["tertiaryPhone"];
        }
    }

    static fromJS(data: any): DealerContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerContactId"] = this.dealerContactId;
        data["dealerId"] = this.dealerId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedById"] = this.lastModifiedById;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["oldsalesforceid"] = this.oldsalesforceid;
        data["secondaryPhone"] = this.secondaryPhone;
        data["tertiaryPhone"] = this.tertiaryPhone;
        return data;
    }

    clone(): DealerContactDto {
        const json = this.toJSON();
        let result = new DealerContactDto();
        result.init(json);
        return result;
    }
}

export interface IDealerContactDto {
    dealerContactId: number;
    dealerId: number;
    firstName: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    createdById: number;
    createdDate: Date;
    lastModifiedById: number;
    lastModifiedDate: Date;
    deleted: boolean;
    oldsalesforceid?: string | undefined;
    secondaryPhone?: string | undefined;
    tertiaryPhone?: string | undefined;
}

export class DealerContactDtoApiResponseDto implements IDealerContactDtoApiResponseDto {
    id!: number;
    payload?: DealerContactDto | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IDealerContactDtoApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payload = _data["payload"] ? DealerContactDto.fromJS(_data["payload"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): DealerContactDtoApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerContactDtoApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): DealerContactDtoApiResponseDto {
        const json = this.toJSON();
        let result = new DealerContactDtoApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IDealerContactDtoApiResponseDto {
    id: number;
    payload?: DealerContactDto | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class DealerContactDtoPagedDataResponseDto implements IDealerContactDtoPagedDataResponseDto {
    data!: DealerContactDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IDealerContactDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DealerContactDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): DealerContactDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerContactDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): DealerContactDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new DealerContactDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IDealerContactDtoPagedDataResponseDto {
    data: DealerContactDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class DealerDto implements IDealerDto {
    active?: boolean | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    bodyShopPhone?: string | undefined;
    termsAndConditions?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    dealerGroupId?: number | undefined;
    dealerId!: number;
    dealerName?: string | undefined;
    dealerNumber?: string | undefined;
    dealerLicenseNumber?: string | undefined;
    dealershipWebsite?: string | undefined;
    server?: string | undefined;
    guid?: string | undefined;
    deleted!: boolean;
    detailingPhone?: string | undefined;
    enableDeletedReason?: boolean | undefined;
    fax?: string | undefined;
    franchise?: boolean | undefined;
    homePageUpdateTime?: Date | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    partsPhone?: string | undefined;
    phone?: string | undefined;
    primaryContactEmail?: string | undefined;
    primaryContactName?: string | undefined;
    principalEmail?: string | undefined;
    principalName?: string | undefined;
    secondaryPhone?: string | undefined;
    servicePhone?: string | undefined;
    state?: string | undefined;
    websiteDisplayName?: string | undefined;
    websiteStyle?: string | undefined;
    misc1?: string | undefined;
    misc2?: string | undefined;
    federalIdNumber?: string | undefined;
    zip?: string | undefined;
    readonly formattedName?: string | undefined;
    buyHerePayHere!: boolean;
    cldisabled?: boolean | undefined;
    contractEndDate?: Date | undefined;
    readonly guidWebsite?: string | undefined;

    constructor(data?: IDealerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.bodyShopPhone = _data["bodyShopPhone"];
            this.termsAndConditions = _data["termsAndConditions"];
            this.city = _data["city"];
            this.county = _data["county"];
            this.dealerGroupId = _data["dealerGroupId"];
            this.dealerId = _data["dealerId"];
            this.dealerName = _data["dealerName"];
            this.dealerNumber = _data["dealerNumber"];
            this.dealerLicenseNumber = _data["dealerLicenseNumber"];
            this.dealershipWebsite = _data["dealershipWebsite"];
            this.server = _data["server"];
            this.guid = _data["guid"];
            this.deleted = _data["deleted"];
            this.detailingPhone = _data["detailingPhone"];
            this.enableDeletedReason = _data["enableDeletedReason"];
            this.fax = _data["fax"];
            this.franchise = _data["franchise"];
            this.homePageUpdateTime = _data["homePageUpdateTime"] ? new Date(_data["homePageUpdateTime"].toString()) : <any>undefined;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.partsPhone = _data["partsPhone"];
            this.phone = _data["phone"];
            this.primaryContactEmail = _data["primaryContactEmail"];
            this.primaryContactName = _data["primaryContactName"];
            this.principalEmail = _data["principalEmail"];
            this.principalName = _data["principalName"];
            this.secondaryPhone = _data["secondaryPhone"];
            this.servicePhone = _data["servicePhone"];
            this.state = _data["state"];
            this.websiteDisplayName = _data["websiteDisplayName"];
            this.websiteStyle = _data["websiteStyle"];
            this.misc1 = _data["misc1"];
            this.misc2 = _data["misc2"];
            this.federalIdNumber = _data["federalIdNumber"];
            this.zip = _data["zip"];
            (<any>this).formattedName = _data["formattedName"];
            this.buyHerePayHere = _data["buyHerePayHere"];
            this.cldisabled = _data["cldisabled"];
            this.contractEndDate = _data["contractEndDate"] ? new Date(_data["contractEndDate"].toString()) : <any>undefined;
            (<any>this).guidWebsite = _data["guidWebsite"];
        }
    }

    static fromJS(data: any): DealerDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["bodyShopPhone"] = this.bodyShopPhone;
        data["termsAndConditions"] = this.termsAndConditions;
        data["city"] = this.city;
        data["county"] = this.county;
        data["dealerGroupId"] = this.dealerGroupId;
        data["dealerId"] = this.dealerId;
        data["dealerName"] = this.dealerName;
        data["dealerNumber"] = this.dealerNumber;
        data["dealerLicenseNumber"] = this.dealerLicenseNumber;
        data["dealershipWebsite"] = this.dealershipWebsite;
        data["server"] = this.server;
        data["guid"] = this.guid;
        data["deleted"] = this.deleted;
        data["detailingPhone"] = this.detailingPhone;
        data["enableDeletedReason"] = this.enableDeletedReason;
        data["fax"] = this.fax;
        data["franchise"] = this.franchise;
        data["homePageUpdateTime"] = this.homePageUpdateTime ? this.homePageUpdateTime.toISOString() : <any>undefined;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["partsPhone"] = this.partsPhone;
        data["phone"] = this.phone;
        data["primaryContactEmail"] = this.primaryContactEmail;
        data["primaryContactName"] = this.primaryContactName;
        data["principalEmail"] = this.principalEmail;
        data["principalName"] = this.principalName;
        data["secondaryPhone"] = this.secondaryPhone;
        data["servicePhone"] = this.servicePhone;
        data["state"] = this.state;
        data["websiteDisplayName"] = this.websiteDisplayName;
        data["websiteStyle"] = this.websiteStyle;
        data["misc1"] = this.misc1;
        data["misc2"] = this.misc2;
        data["federalIdNumber"] = this.federalIdNumber;
        data["zip"] = this.zip;
        data["formattedName"] = this.formattedName;
        data["buyHerePayHere"] = this.buyHerePayHere;
        data["cldisabled"] = this.cldisabled;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : <any>undefined;
        data["guidWebsite"] = this.guidWebsite;
        return data;
    }

    clone(): DealerDto {
        const json = this.toJSON();
        let result = new DealerDto();
        result.init(json);
        return result;
    }
}

export interface IDealerDto {
    active?: boolean | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    bodyShopPhone?: string | undefined;
    termsAndConditions?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    dealerGroupId?: number | undefined;
    dealerId: number;
    dealerName?: string | undefined;
    dealerNumber?: string | undefined;
    dealerLicenseNumber?: string | undefined;
    dealershipWebsite?: string | undefined;
    server?: string | undefined;
    guid?: string | undefined;
    deleted: boolean;
    detailingPhone?: string | undefined;
    enableDeletedReason?: boolean | undefined;
    fax?: string | undefined;
    franchise?: boolean | undefined;
    homePageUpdateTime?: Date | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    partsPhone?: string | undefined;
    phone?: string | undefined;
    primaryContactEmail?: string | undefined;
    primaryContactName?: string | undefined;
    principalEmail?: string | undefined;
    principalName?: string | undefined;
    secondaryPhone?: string | undefined;
    servicePhone?: string | undefined;
    state?: string | undefined;
    websiteDisplayName?: string | undefined;
    websiteStyle?: string | undefined;
    misc1?: string | undefined;
    misc2?: string | undefined;
    federalIdNumber?: string | undefined;
    zip?: string | undefined;
    formattedName?: string | undefined;
    buyHerePayHere: boolean;
    cldisabled?: boolean | undefined;
    contractEndDate?: Date | undefined;
    guidWebsite?: string | undefined;
}

export class DealerDtoPagedDataResponseDto implements IDealerDtoPagedDataResponseDto {
    data!: DealerDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IDealerDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DealerDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): DealerDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): DealerDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new DealerDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IDealerDtoPagedDataResponseDto {
    data: DealerDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class DealerIdsNamesDto implements IDealerIdsNamesDto {
    dealerId!: number;
    dealerName?: string | undefined;
    readonly formattedName?: string | undefined;
    deleted!: boolean;

    constructor(data?: IDealerIdsNamesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
            this.dealerName = _data["dealerName"];
            (<any>this).formattedName = _data["formattedName"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): DealerIdsNamesDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerIdsNamesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        data["dealerName"] = this.dealerName;
        data["formattedName"] = this.formattedName;
        data["deleted"] = this.deleted;
        return data;
    }

    clone(): DealerIdsNamesDto {
        const json = this.toJSON();
        let result = new DealerIdsNamesDto();
        result.init(json);
        return result;
    }
}

export interface IDealerIdsNamesDto {
    dealerId: number;
    dealerName?: string | undefined;
    formattedName?: string | undefined;
    deleted: boolean;
}

export class DealerIdsNamesDtoPagedDataResponseDto implements IDealerIdsNamesDtoPagedDataResponseDto {
    data!: DealerIdsNamesDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IDealerIdsNamesDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DealerIdsNamesDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): DealerIdsNamesDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerIdsNamesDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): DealerIdsNamesDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new DealerIdsNamesDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IDealerIdsNamesDtoPagedDataResponseDto {
    data: DealerIdsNamesDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class DealerIdsNamesTimeZonesDto implements IDealerIdsNamesTimeZonesDto {
    dealerId!: number;
    dealerName?: string | undefined;
    timeZoneId!: number;
    timeZone?: string | undefined;
    readonly formattedName?: string | undefined;
    deleted!: boolean;

    constructor(data?: IDealerIdsNamesTimeZonesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
            this.dealerName = _data["dealerName"];
            this.timeZoneId = _data["timeZoneId"];
            this.timeZone = _data["timeZone"];
            (<any>this).formattedName = _data["formattedName"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): DealerIdsNamesTimeZonesDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerIdsNamesTimeZonesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        data["dealerName"] = this.dealerName;
        data["timeZoneId"] = this.timeZoneId;
        data["timeZone"] = this.timeZone;
        data["formattedName"] = this.formattedName;
        data["deleted"] = this.deleted;
        return data;
    }

    clone(): DealerIdsNamesTimeZonesDto {
        const json = this.toJSON();
        let result = new DealerIdsNamesTimeZonesDto();
        result.init(json);
        return result;
    }
}

export interface IDealerIdsNamesTimeZonesDto {
    dealerId: number;
    dealerName?: string | undefined;
    timeZoneId: number;
    timeZone?: string | undefined;
    formattedName?: string | undefined;
    deleted: boolean;
}

export class DealerIdsNamesTimeZonesDtoPagedDataResponseDto implements IDealerIdsNamesTimeZonesDtoPagedDataResponseDto {
    data!: DealerIdsNamesTimeZonesDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IDealerIdsNamesTimeZonesDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DealerIdsNamesTimeZonesDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): DealerIdsNamesTimeZonesDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerIdsNamesTimeZonesDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): DealerIdsNamesTimeZonesDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new DealerIdsNamesTimeZonesDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IDealerIdsNamesTimeZonesDtoPagedDataResponseDto {
    data: DealerIdsNamesTimeZonesDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class DealerInvoiceTotalsDto implements IDealerInvoiceTotalsDto {
    openInvoiceTotal!: number;
    pastDueInvoiceTotal!: number;

    constructor(data?: IDealerInvoiceTotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openInvoiceTotal = _data["openInvoiceTotal"];
            this.pastDueInvoiceTotal = _data["pastDueInvoiceTotal"];
        }
    }

    static fromJS(data: any): DealerInvoiceTotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerInvoiceTotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openInvoiceTotal"] = this.openInvoiceTotal;
        data["pastDueInvoiceTotal"] = this.pastDueInvoiceTotal;
        return data;
    }

    clone(): DealerInvoiceTotalsDto {
        const json = this.toJSON();
        let result = new DealerInvoiceTotalsDto();
        result.init(json);
        return result;
    }
}

export interface IDealerInvoiceTotalsDto {
    openInvoiceTotal: number;
    pastDueInvoiceTotal: number;
}

export class DealerOwnerDto implements IDealerOwnerDto {
    ownerName?: string | undefined;

    constructor(data?: IDealerOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerName = _data["ownerName"];
        }
    }

    static fromJS(data: any): DealerOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerName"] = this.ownerName;
        return data;
    }

    clone(): DealerOwnerDto {
        const json = this.toJSON();
        let result = new DealerOwnerDto();
        result.init(json);
        return result;
    }
}

export interface IDealerOwnerDto {
    ownerName?: string | undefined;
}

export class DealerStatusDto implements IDealerStatusDto {
    dealerStatusId!: number;
    dealerStatus?: string | undefined;
    dealerStatusType!: DealerStatusEnum;

    constructor(data?: IDealerStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerStatusId = _data["dealerStatusId"];
            this.dealerStatus = _data["dealerStatus"];
            this.dealerStatusType = _data["dealerStatusType"];
        }
    }

    static fromJS(data: any): DealerStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerStatusId"] = this.dealerStatusId;
        data["dealerStatus"] = this.dealerStatus;
        data["dealerStatusType"] = this.dealerStatusType;
        return data;
    }

    clone(): DealerStatusDto {
        const json = this.toJSON();
        let result = new DealerStatusDto();
        result.init(json);
        return result;
    }
}

export interface IDealerStatusDto {
    dealerStatusId: number;
    dealerStatus?: string | undefined;
    dealerStatusType: DealerStatusEnum;
}

export enum DealerStatusEnum {
    Undefined = "Undefined",
    Active = "Active",
    PastDue = "PastDue",
    Parked = "Parked",
    Saved = "Saved",
    Cancelled = "Cancelled",
    Deleted = "Deleted",
    OutsideCollections = "OutsideCollections",
    DeletedForNonPayment = "DeletedForNonPayment",
    AtRisk = "AtRisk",
}

export enum DeletedStateEnum {
    Undefined = "Undefined",
    Active = "Active",
    Deleted = "Deleted",
    Both = "Both",
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    MovedPermanently = "MovedPermanently",
    Found = "Found",
    SeeOther = "SeeOther",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export class ProductDealerDto implements IProductDealerDto {
    productDealerId!: number;
    dealerId?: number | undefined;
    dealerGroupId?: number | undefined;
    productId?: number | undefined;
    productName?: string | undefined;
    productCost?: number | undefined;
    productCode?: string | undefined;
    trialStartDate?: Date | undefined;
    trialEndDate?: Date | undefined;
    firstBillDate?: Date | undefined;
    billMonth?: number | undefined;
    billDay?: number | undefined;
    billYear?: number | undefined;
    deletionDate?: Date | undefined;
    createdDate?: Date | undefined;
    lastModifiedDate?: Date | undefined;
    createdById?: number | undefined;
    lastModifiedById?: number | undefined;
    primaryProduct?: boolean | undefined;
    note?: string | undefined;
    deleted?: boolean | undefined;
    ownerId?: number | undefined;
    productDealerStatusId?: number | undefined;
    contractEndDate?: Date | undefined;
    savedById?: number | undefined;
    quantity?: number | undefined;
    savedDate?: Date | undefined;
    salesPersonId?: number | undefined;
    replacingProductDealerId?: number | undefined;
    productOwnerName?: string | undefined;
    status?: string | undefined;

    constructor(data?: IProductDealerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productDealerId = _data["productDealerId"];
            this.dealerId = _data["dealerId"];
            this.dealerGroupId = _data["dealerGroupId"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productCost = _data["productCost"];
            this.productCode = _data["productCode"];
            this.trialStartDate = _data["trialStartDate"] ? new Date(_data["trialStartDate"].toString()) : <any>undefined;
            this.trialEndDate = _data["trialEndDate"] ? new Date(_data["trialEndDate"].toString()) : <any>undefined;
            this.firstBillDate = _data["firstBillDate"] ? new Date(_data["firstBillDate"].toString()) : <any>undefined;
            this.billMonth = _data["billMonth"];
            this.billDay = _data["billDay"];
            this.billYear = _data["billYear"];
            this.deletionDate = _data["deletionDate"] ? new Date(_data["deletionDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.lastModifiedById = _data["lastModifiedById"];
            this.primaryProduct = _data["primaryProduct"];
            this.note = _data["note"];
            this.deleted = _data["deleted"];
            this.ownerId = _data["ownerId"];
            this.productDealerStatusId = _data["productDealerStatusId"];
            this.contractEndDate = _data["contractEndDate"] ? new Date(_data["contractEndDate"].toString()) : <any>undefined;
            this.savedById = _data["savedById"];
            this.quantity = _data["quantity"];
            this.savedDate = _data["savedDate"] ? new Date(_data["savedDate"].toString()) : <any>undefined;
            this.salesPersonId = _data["salesPersonId"];
            this.replacingProductDealerId = _data["replacingProductDealerId"];
            this.productOwnerName = _data["productOwnerName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ProductDealerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDealerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productDealerId"] = this.productDealerId;
        data["dealerId"] = this.dealerId;
        data["dealerGroupId"] = this.dealerGroupId;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productCost"] = this.productCost;
        data["productCode"] = this.productCode;
        data["trialStartDate"] = this.trialStartDate ? this.trialStartDate.toISOString() : <any>undefined;
        data["trialEndDate"] = this.trialEndDate ? this.trialEndDate.toISOString() : <any>undefined;
        data["firstBillDate"] = this.firstBillDate ? this.firstBillDate.toISOString() : <any>undefined;
        data["billMonth"] = this.billMonth;
        data["billDay"] = this.billDay;
        data["billYear"] = this.billYear;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["lastModifiedById"] = this.lastModifiedById;
        data["primaryProduct"] = this.primaryProduct;
        data["note"] = this.note;
        data["deleted"] = this.deleted;
        data["ownerId"] = this.ownerId;
        data["productDealerStatusId"] = this.productDealerStatusId;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : <any>undefined;
        data["savedById"] = this.savedById;
        data["quantity"] = this.quantity;
        data["savedDate"] = this.savedDate ? this.savedDate.toISOString() : <any>undefined;
        data["salesPersonId"] = this.salesPersonId;
        data["replacingProductDealerId"] = this.replacingProductDealerId;
        data["productOwnerName"] = this.productOwnerName;
        data["status"] = this.status;
        return data;
    }

    clone(): ProductDealerDto {
        const json = this.toJSON();
        let result = new ProductDealerDto();
        result.init(json);
        return result;
    }
}

export interface IProductDealerDto {
    productDealerId: number;
    dealerId?: number | undefined;
    dealerGroupId?: number | undefined;
    productId?: number | undefined;
    productName?: string | undefined;
    productCost?: number | undefined;
    productCode?: string | undefined;
    trialStartDate?: Date | undefined;
    trialEndDate?: Date | undefined;
    firstBillDate?: Date | undefined;
    billMonth?: number | undefined;
    billDay?: number | undefined;
    billYear?: number | undefined;
    deletionDate?: Date | undefined;
    createdDate?: Date | undefined;
    lastModifiedDate?: Date | undefined;
    createdById?: number | undefined;
    lastModifiedById?: number | undefined;
    primaryProduct?: boolean | undefined;
    note?: string | undefined;
    deleted?: boolean | undefined;
    ownerId?: number | undefined;
    productDealerStatusId?: number | undefined;
    contractEndDate?: Date | undefined;
    savedById?: number | undefined;
    quantity?: number | undefined;
    savedDate?: Date | undefined;
    salesPersonId?: number | undefined;
    replacingProductDealerId?: number | undefined;
    productOwnerName?: string | undefined;
    status?: string | undefined;
}

export class ProductDealerDtoPagedDataResponseDto implements IProductDealerDtoPagedDataResponseDto {
    data!: ProductDealerDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IProductDealerDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProductDealerDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): ProductDealerDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDealerDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): ProductDealerDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new ProductDealerDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface IProductDealerDtoPagedDataResponseDto {
    data: ProductDealerDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class ProductDealerWithTotalsDto implements IProductDealerWithTotalsDto {
    products?: ProductDealerDtoPagedDataResponseDto | undefined;
    totalProductCost?: TotalProductCostDto | undefined;

    constructor(data?: IProductDealerWithTotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.products = _data["products"] ? ProductDealerDtoPagedDataResponseDto.fromJS(_data["products"]) : <any>undefined;
            this.totalProductCost = _data["totalProductCost"] ? TotalProductCostDto.fromJS(_data["totalProductCost"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductDealerWithTotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDealerWithTotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["products"] = this.products ? this.products.toJSON() : <any>undefined;
        data["totalProductCost"] = this.totalProductCost ? this.totalProductCost.toJSON() : <any>undefined;
        return data;
    }

    clone(): ProductDealerWithTotalsDto {
        const json = this.toJSON();
        let result = new ProductDealerWithTotalsDto();
        result.init(json);
        return result;
    }
}

export interface IProductDealerWithTotalsDto {
    products?: ProductDealerDtoPagedDataResponseDto | undefined;
    totalProductCost?: TotalProductCostDto | undefined;
}

export enum ProductTypeEnum {
    Dealer = "Dealer",
    Case = "Case",
}

export class TestDto implements ITestDto {
    prop?: string | undefined;

    constructor(data?: ITestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prop = _data["prop"];
        }
    }

    static fromJS(data: any): TestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prop"] = this.prop;
        return data;
    }

    clone(): TestDto {
        const json = this.toJSON();
        let result = new TestDto();
        result.init(json);
        return result;
    }
}

export interface ITestDto {
    prop?: string | undefined;
}

export class TimeZoneDto implements ITimeZoneDto {
    timeZoneId!: number;
    timeZoneName?: string | undefined;
    googleTimeZoneId?: string | undefined;
    gmtoffset!: number;

    constructor(data?: ITimeZoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneId = _data["timeZoneId"];
            this.timeZoneName = _data["timeZoneName"];
            this.googleTimeZoneId = _data["googleTimeZoneId"];
            this.gmtoffset = _data["gmtoffset"];
        }
    }

    static fromJS(data: any): TimeZoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneId"] = this.timeZoneId;
        data["timeZoneName"] = this.timeZoneName;
        data["googleTimeZoneId"] = this.googleTimeZoneId;
        data["gmtoffset"] = this.gmtoffset;
        return data;
    }

    clone(): TimeZoneDto {
        const json = this.toJSON();
        let result = new TimeZoneDto();
        result.init(json);
        return result;
    }
}

export interface ITimeZoneDto {
    timeZoneId: number;
    timeZoneName?: string | undefined;
    googleTimeZoneId?: string | undefined;
    gmtoffset: number;
}

export class TimeZoneDtoNotPagedDataResponseDto implements ITimeZoneDtoNotPagedDataResponseDto {
    data!: TimeZoneDto[];
    totalItems?: number | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ITimeZoneDtoNotPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TimeZoneDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): TimeZoneDtoNotPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneDtoNotPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): TimeZoneDtoNotPagedDataResponseDto {
        const json = this.toJSON();
        let result = new TimeZoneDtoNotPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ITimeZoneDtoNotPagedDataResponseDto {
    data: TimeZoneDto[];
    totalItems?: number | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class TotalProductCostDto implements ITotalProductCostDto {
    totalProductCost?: number | undefined;

    constructor(data?: ITotalProductCostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProductCost = _data["totalProductCost"];
        }
    }

    static fromJS(data: any): TotalProductCostDto {
        data = typeof data === 'object' ? data : {};
        let result = new TotalProductCostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProductCost"] = this.totalProductCost;
        return data;
    }

    clone(): TotalProductCostDto {
        const json = this.toJSON();
        let result = new TotalProductCostDto();
        result.init(json);
        return result;
    }
}

export interface ITotalProductCostDto {
    totalProductCost?: number | undefined;
}

export class V1ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isV1ApiException = true;

    static isV1ApiException(obj: any): obj is V1ApiException {
        return obj.isV1ApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new V1ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}